var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUsContact3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1911_148702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0547 64.8438H8.78906C3.94258 64.8438 0 60.9012 0 56.0547V8.78906C0 3.94258 3.94258 0 8.78906 0H91.2109C96.0574 0 100 3.94258 100 8.78906V56.0547C100 56.973 99.5709 57.84 98.8326 58.3949C98.0945 58.9471 97.1561 59.1217 96.2635 58.8727L76.5625 53.2424L58.9844 58.2635V61.9141C58.9844 63.5334 57.674 64.8438 56.0547 64.8438Z",
    fill: "#FF6A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2109 0H50.1953V64.8438H56.0547C57.674 64.8438 58.9844 63.5334 58.9844 61.9141V58.2635L76.5625 53.2424L96.2635 58.8728C97.1561 59.1217 98.0945 58.9473 98.8326 58.3951C99.5707 57.84 100 56.9732 100 56.0549V8.78906C100 3.94258 96.0574 0 91.2109 0Z",
    fill: "#F23030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8984 41.4062H15.0391C13.4197 41.4062 12.1094 42.7166 12.1094 44.3359C12.1094 45.9553 13.4197 47.2656 15.0391 47.2656H20.8984C22.5178 47.2656 23.8281 45.9553 23.8281 44.3359C23.8281 42.7166 22.5178 41.4062 20.8984 41.4062Z",
    fill: "#F23030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4766 41.4062H32.6172C30.9979 41.4062 29.6875 42.7166 29.6875 44.3359C29.6875 45.9553 30.9979 47.2656 32.6172 47.2656H38.4766C40.0959 47.2656 41.4062 45.9553 41.4062 44.3359C41.4062 42.7166 40.0959 41.4062 38.4766 41.4062Z",
    fill: "#F23030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3516 17.9688H53.125C51.5057 17.9688 50.1953 19.2791 50.1953 20.8984C50.1953 22.5178 51.5057 23.8281 53.125 23.8281H85.3516C86.9709 23.8281 88.2812 22.5178 88.2812 20.8984C88.2812 19.2791 86.9709 17.9688 85.3516 17.9688Z",
    fill: "#CC1414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5625 100C76.2695 100 76.035 99.9417 75.7422 99.8829C62.4416 96.0741 53.125 83.7696 53.125 69.8829V56.055C53.125 54.7657 54.0041 53.5938 55.2344 53.2423L75.7578 47.3784C76.2838 47.228 76.8414 47.228 77.3676 47.3784L97.891 53.2423C99.1213 53.5938 100 54.7657 100 56.055V69.8831C100 83.7698 90.6838 96.0743 77.3832 99.8831C77.09 99.9417 76.8555 100 76.5625 100Z",
    fill: "#8DF4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 69.883V56.0549C100 54.7656 99.1211 53.5938 97.8908 53.2422L77.3674 47.3783C77.1043 47.3031 76.8334 47.2656 76.5625 47.2656V100C76.8555 100 77.09 99.9416 77.3828 99.8828C90.6836 96.0742 100 83.7695 100 69.883Z",
    fill: "#7ADFE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5625 94.0086C66.1711 90.6586 58.9844 80.8557 58.9844 69.8828V58.2645L76.5625 53.2422L94.1406 58.2645V69.8828C94.1406 80.8555 86.9539 90.6586 76.5625 94.0086Z",
    fill: "#7ADFE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1406 69.8828V58.2645L76.5625 53.2422V94.0088C86.9539 90.6586 94.1406 80.8555 94.1406 69.8828Z",
    fill: "#55B3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6327 82.4219C72.8831 82.4219 72.1334 82.1358 71.5614 81.5635L65.702 75.7042C64.5577 74.5598 64.5577 72.7057 65.702 71.5614C66.8463 70.417 68.7004 70.417 69.8448 71.5614L73.6327 75.3495L83.2801 65.702C84.4245 64.5577 86.2786 64.5577 87.4229 65.702C88.5672 66.8463 88.5672 68.7004 87.4229 69.8448L75.7042 81.5635C75.1319 82.1358 74.3823 82.4219 73.6327 82.4219Z",
    fill: "#F3F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2803 65.7021L76.5625 72.4197V80.7052L87.4229 69.8448C88.5672 68.7005 88.5672 66.8464 87.4229 65.7021C86.2785 64.5577 84.4246 64.5575 83.2803 65.7021Z",
    fill: "#E1E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7031 29.6875C15.8568 29.6875 11.9141 25.7447 11.9141 20.8984C11.9141 16.0521 15.8568 12.1094 20.7031 12.1094C25.5494 12.1094 29.4922 16.0521 29.4922 20.8984C29.4922 25.7447 25.5494 29.6875 20.7031 29.6875Z",
    fill: "#FFDF40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1911_148702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsContact3);
export default __webpack_public_path__ + "static/media/about_us_contact3.2ce2d574cec0c60ff18c1a819548264b.svg";
export { ForwardRef as ReactComponent };